import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutValues = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Confianza',
      description: 'Construimos relaciones basadas en transparencia, seguridad y cumplimiento de compromisos. Tu información está protegida y tus documentos son revisados por profesionales certificados.',
    },
    {
      icon: 'ri-time-line',
      title: 'Rapidez',
      description: 'Valoramos tu tiempo. Entregamos servicios legales en días, no semanas, gracias a metodologías eficientes y procesos optimizados.',
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Eficiencia',
      description: 'Maximizamos resultados minimizando tiempos y costos. Nuestros procesos están diseñados para eliminar burocracia innecesaria y enfocarnos en lo que realmente importa.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Claridad jurídica',
      description: 'El lenguaje legal no tiene que ser complicado. Explicamos cada documento y proceso de forma clara y comprensible para que tomes decisiones informadas.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Innovación tecnológica',
      description: 'Adoptamos las últimas tecnologías para mejorar continuamente nuestros servicios. La tecnología es nuestra aliada para ofrecer soluciones de vanguardia.',
    },
  ];

  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            Nuestros Valores
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Los principios que guían cada decisión y acción en Bala Corp
          </p>
        </motion.div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="bg-white rounded-2xl p-8 hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-primary-yellow rounded-xl mb-6">
                <i className={`${value.icon} text-3xl text-black`}></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">
                {value.title}
              </h3>
              <p className="text-gray-dark leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="text-center bg-primary-yellow rounded-3xl p-12"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-black mb-4">
            ¿Quieres ser parte de la revolución legaltech?
          </h3>
          <p className="text-xl text-gray-dark mb-8 max-w-2xl mx-auto">
            Únete a las empresas que ya están transformando la forma en que gestionan sus necesidades legales
          </p>
          <Link
            to="/contacto"
            className="inline-block bg-black text-primary-yellow px-10 py-4 rounded-full font-bold hover:bg-gray-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Comenzar ahora
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutValues;